// extracted by mini-css-extract-plugin
export default {"error":"Qm4AQ","error-content":"scE0o","error-content__text":"vDdOc"};